import React, { PureComponent, createElement, Fragment, useEffect } from 'react';
import {
    message,
    Dropdown,
    Menu,
    Button,
    Icon,
    Modal,
    Form,
    Input,
    Radio,
    Card,
    Select,
    Table,
    Checkbox,
    Row,
    Col,
    DatePicker,
    Popconfirm,
} from 'antd';
import { Entity } from '@comall-backend-builder/core/lib/parser';
import { services } from '@comall-backend-builder/core';

import { FormComponentProps } from 'antd/es/form';
import './index.less';
import { get, set } from 'lodash';
import { errorHandle } from '../../services';
const { TextArea } = Input;
const { Option } = Select;
const { RangePicker } = DatePicker;
const confirmProps = {
    title: '确定要删除吗？',
    okText: '确定',
    cancelText: '取消',
};
const api = services.api;

export interface SynonymListViewProps {
    form: any;
    handelClose?: () => void;
    selectedData?: any;
}

export interface IState {
    visible: boolean;
    black_remark: string;
    visibleClear: boolean;
    clearType: boolean;
    productModal: {
        visible: boolean;
        type: string;
    };
}
const AddSynonym = ({ form, handelClose, selectedData }: SynonymListViewProps) => {
    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        form.validateFields((err: any, values: any) => {
            if (!err) {
                if (selectedData.brandCode) {
                    api.post(
                        {
                            ...values,
                            mainWords: values.mainWords.trim(),
                            agreementWords: values.agreementWords.trim(),
                            tagAgreementCode: selectedData.tagAgreementCode,
                        },
                        { apiPath: '/searchTag/agreementUpdate' }
                    )
                        .then((res: any) => {
                            if (res && res.resultCode === 200) {
                                form.resetFields();
                                message.success('修改成功');
                                handelClose && handelClose();
                            } else {
                                message.error(res.resultMsg || '修改失败');
                            }
                        })
                        .catch(errorHandle);
                } else {
                    api.post(
                        {
                            ...values,
                            mainWords: values.mainWords.trim(),
                            agreementWords: values.agreementWords.trim(),
                        },
                        { apiPath: '/searchTag/agreementAdd' }
                    ).then((res: any) => {
                        if (res && res.resultCode === 200) {
                            message.success('添加成功');
                            form.resetFields();
                            handelClose && handelClose();
                        } else {
                            message.error(res.resultMsg || '修改失败');
                        }
                    });
                }
            }
        });
    };
    const synonymLabel = (
        <div style={{ display: 'inline-block' }}>
            <span>同义词:</span>
            <span style={{ fontSize: 11, color: '#999' }}>
                (多值以英文分号隔开,例:劳力士;Rolex)
            </span>
        </div>
    );
    useEffect(() => {
        if (selectedData) {
            form.setFieldsValue({
                mainWords: selectedData.mainWords,
                agreementWords: selectedData.agreementWords,
            });
        }
    }, [selectedData]);
    return (
        <Form
            layout="vertical"
            onSubmit={(e) => {
                handleSubmit(e);
                return false;
            }}
        >
            <Form.Item label="Query">
                {form.getFieldDecorator('mainWords', {
                    rules: [
                        { required: true, message: '请输入内容' },
                        {
                            max: 20,
                            message: 'Query长度不能超过20个字符',
                        },
                        {
                            validator: (rule, value, callback) => {
                                if (value && value.trim() === '') {
                                    callback('Query不能为空格');
                                } else {
                                    callback();
                                }
                            },
                        },
                    ],
                })(<Input placeholder="输入内容" />)}
            </Form.Item>
            <Form.Item label={synonymLabel}>
                {form.getFieldDecorator('agreementWords', {
                    rules: [
                        { required: true, message: '请输入内容' },
                        {
                            max: 500,
                            message: '同义词长度不能超过500个字符',
                        },
                        {
                            validator: (rule, value, callback) => {
                                if (value && value.trim() === '') {
                                    callback('同义词不能为空格');
                                } else {
                                    callback();
                                }
                            },
                        },
                    ],
                })(<TextArea placeholder="输入内容" />)}
            </Form.Item>
            <Row>
                <Col span={24} style={{ textAlign: 'right' }}>
                    <Button type="primary" htmlType="submit">
                        保存
                    </Button>
                    <Button style={{ marginLeft: 8 }} onClick={handelClose}>
                        取消
                    </Button>
                </Col>
            </Row>
        </Form>
    );
};

const AddSynonymForm = Form.create<SynonymListViewProps>({ name: 'advanced_search' })(AddSynonym);

// 商品经营管理
const SynonymListView = ({ form }: SynonymListViewProps) => {
    const [visible, setVisible] = React.useState(false);
    const [pageSize, setPageSize] = React.useState(10);
    const [pageNum, setPageNum] = React.useState(1);
    const [total, setTotal] = React.useState(0);
    const [tableData, setTableData] = React.useState([]);
    const [searchParams, setSearchParams] = React.useState({});
    const [selectedData, setSelectedData] = React.useState({});
    const columns = [
        {
            title: 'Query',
            dataIndex: 'mainWords',
            key: 'mainWords',
            align: 'center' as const,
        },
        {
            dataIndex: 'agreementWords',
            title: () => (
                <>
                    <div>同义词</div>
                    <div style={{ fontSize: 11, color: '#999' }}>
                        多值以英文分号隔开,例:劳力士;Rolex
                    </div>
                </>
            ),
            key: 'agreementWords',
            align: 'center' as const,
        },
        {
            title: '更新人',
            dataIndex: 'updateByName',
            key: 'updateByName',
            align: 'center' as const,
        },
        {
            title: '更新时间',
            dataIndex: 'updateTime',
            key: 'updateTime',
            align: 'center' as const,
        },
        {
            title: '操作',
            align: 'center' as const,
            render: (_, record) => [
                <Button
                    size="small"
                    type="link"
                    onClick={() => {
                        setSelectedData(record);
                        setVisible(true);
                    }}
                >
                    编辑
                </Button>,
                <Popconfirm
                    {...confirmProps}
                    onConfirm={() => {
                        api.get(
                            {},
                            { apiPath: `/searchTag/agreementDelete/${record.tagAgreementCode}` }
                        )
                            .then((res: any) => {
                                if (res && res.resultCode === 200) {
                                    getList({ page: 1, per_page: pageSize });
                                }
                            })
                            .catch(errorHandle);
                    }}
                >
                    <Button size="small" type="link">
                        删除
                    </Button>
                </Popconfirm>,
            ],
        },
    ];

    const getList = (data) => {
        api.get(data, { apiPath: '/searchTag/agreementQueryPage' })
            .then((res: any) => {
                if (res && res.result) {
                    setTableData(res.result);
                    setPageNum(res.page);
                    setTotal(res.totalNum);
                }
            })
            .catch(errorHandle);
    };
    const handleSubmit = () => {
        form.validateFields((err, values) => {
            if (!err) {
                const params = {
                    ...values,
                    page: 1,
                    per_page: pageSize,
                    startUpdateTime:
                        values.updateTime && values.updateTime[0]
                            ? values.updateTime[0].format('YYYY-MM-DD')
                            : undefined,
                    endUpdateTime:
                        values.updateTime && values.updateTime[1]
                            ? values.updateTime[1].format('YYYY-MM-DD')
                            : undefined,
                };
                delete params.updateTime;
                setSearchParams(params);
                getList(params);
            }
        });
    };
    const handleCancel = () => {
        setVisible(false);
    };
    useEffect(() => {
        getList({ page: 1, per_page: pageSize });
    }, []);
    return (
        <>
            <Card>
                <Row>
                    <Form
                        layout="inline"
                        onSubmit={(e) => {
                            e.preventDefault();
                            handleSubmit();
                        }}
                    >
                        <Form.Item label="Query">
                            {form.getFieldDecorator(
                                'mainWords',
                                {}
                            )(<Input placeholder="输入内容" />)}
                        </Form.Item>
                        <Form.Item label="同义词">
                            {form.getFieldDecorator(
                                'agreementWords',
                                {}
                            )(<Input placeholder="输入内容" />)}
                        </Form.Item>

                        <Form.Item label="更新人">
                            {form.getFieldDecorator(
                                'updateByName',
                                {}
                            )(<Input placeholder="输入内容" />)}
                        </Form.Item>
                        <Form.Item label="更新时间">
                            {form.getFieldDecorator(
                                'updateTime',
                                {}
                            )(<RangePicker placeholder={['开始时间', '结束时间']} />)}
                        </Form.Item>
                        <Form.Item>
                            <Button
                                type="primary"
                                style={{ marginRight: 8, marginBottom: 18 }}
                                htmlType="submit"
                            >
                                查询
                            </Button>
                            <Button onClick={() => form.resetFields()}>重置</Button>
                        </Form.Item>
                    </Form>
                </Row>
                <Row>
                    <Button
                        type="primary"
                        style={{ marginBottom: 18 }}
                        onClick={() => {
                            setVisible(true);
                        }}
                    >
                        新增
                    </Button>
                </Row>
                <Table
                    columns={columns}
                    dataSource={tableData}
                    pagination={{
                        total: total,
                        showSizeChanger: true,
                        showQuickJumper: true,
                        pageSizeOptions: ['10', '15', '20'],
                        pageSize: pageSize,
                        current: pageNum,
                        showTotal: (total, range) => `共 ${total} 条记录`,
                        onChange: (page) => {
                            getList({ ...searchParams, page, per_page: pageSize });
                        },
                        onShowSizeChange: (current, size) => {
                            setPageSize(size);
                            getList({ ...searchParams, page: current, per_page: size });
                        },
                    }}
                />
                <Modal
                    visible={visible}
                    title="设置同义词"
                    footer={null}
                    width={900}
                    onCancel={() => {
                        setVisible(false);
                        setSelectedData([]);
                    }}
                    destroyOnClose
                >
                    <AddSynonymForm
                        selectedData={selectedData}
                        handelClose={() => {
                            setVisible(false);
                            setSelectedData([]);
                            getList({ ...searchParams, page: 1, per_page: pageSize });
                        }}
                    />
                </Modal>
            </Card>
        </>
    );
};

export const synonymListView = Form.create()(SynonymListView);
